var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeContent.error)?_c('core-alert',{attrs:{"type":"error"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.activeContent.error)}})]):_vm._e(),(_vm.activeContent.message)?_c('core-alert',{attrs:{"type":"info"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.activeContent.message)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }